// File: components/Wire24DataTable/Wire24DataTable.jsx

import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table';
import { TableHeader } from './TableHeader';
import { TableBody } from './TableBody';
import { GlobalSearch } from './GlobalSearch';
import { SkeletonRows } from './SkeletonRows';
import { EmptyState } from './EmptyState';
import { UnstructuredDataPagination } from '../Pagination/UnstructuredDataPagination';
import './wire24TableStyles.css';

export const DataTable = ({
  columns,
  data,
  isLoading,
  enableMultiSort = true,
  pageSizeOptions = [10, 25, 50],
  defaultPageSize = 10,
  onRowClick,
}) => {
  const [globalFilter, setGlobalFilter] = useState('');
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const table = useReactTable({
    data,
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    enableMultiSort,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    debugTable: false,
  });

  const currentPage = table.getState().pagination.pageIndex + 1;
  const totalPages = table.getPageCount();

  console.log(table);

  return (
    <div className="wire24-table-wrapper">
      

      <div className="table-responsive">
        <table className="wire24-table">
          <TableHeader table={table} />
          {isLoading ? (
            <SkeletonRows columns={columns} />
          ) : table.getRowModel().rows?.length > 0 ? (
            <TableBody table={table} onRowClick={onRowClick} />
          ) : (
            <EmptyState message="No records found." />
          )}
        </table>
      </div>
      <div className="mx-5 mb-3">
        <UnstructuredDataPagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={data.length}
          onPageChange={(page) => table.setPageIndex(page - 1)}
          label="rows"
        />
      </div>
    </div>
  );
};

DataTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  enableMultiSort: PropTypes.bool,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  defaultPageSize: PropTypes.number,
  onRowClick: PropTypes.func,
};
